import { render, staticRenderFns } from "./SocialSharePage.vue?vue&type=template&id=4f819ad0&"
import script from "./SocialSharePage.vue?vue&type=script&lang=js&"
export * from "./SocialSharePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports